import { render, staticRenderFns } from "./RedeemOfferItemProperty.vue?vue&type=template&id=7b097b54&scoped=true&lang=pug&"
import script from "./RedeemOfferItemProperty.vue?vue&type=script&lang=js&"
export * from "./RedeemOfferItemProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b097b54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VIcon,VRadio})
